module.exports = __webpack_public_path__ + "img/04车门控制器软件著作权.e5e38422.png";